import React from 'react'
import { withIcon } from '../../withIcon'

interface SparkleIconProps {
  size?: string
  color?: string
}

/**
 * 4-point sparkle / twinkle, stroked (not filled).
 *
 * Per Figma node 3663-104331 (Create a Vibe Line modal header label).
 * Path copied verbatim from the Figma export.
 */
function SparkleIcon (props: SparkleIconProps) {
  const {
    size = '16px',
    color = 'currentColor',
  } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 1L7.08895 4.64419C6.91118 5.35529 6.82229 5.71084 6.63716 6.00016C6.47341 6.25607 6.25607 6.47341 6.00016 6.63716C5.71084 6.82229 5.35529 6.91118 4.64419 7.08895L1 8L4.64419 8.91105C5.35529 9.08882 5.71084 9.17771 6.00016 9.36284C6.25607 9.52659 6.47341 9.74393 6.63716 9.99984C6.82229 10.2892 6.91118 10.6447 7.08895 11.3558L8 15L8.91105 11.3558C9.08882 10.6447 9.17771 10.2892 9.36284 9.99984C9.52659 9.74393 9.74393 9.52659 9.99984 9.36284C10.2892 9.17771 10.6447 9.08882 11.3558 8.91105L15 8L11.3558 7.08895C10.6447 6.91118 10.2892 6.82229 9.99984 6.63716C9.74393 6.47341 9.52659 6.25607 9.36284 6.00016C9.17771 5.71084 9.08882 5.35529 8.91105 4.64419L8 1Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default withIcon(SparkleIcon)
